const apiUrl = import.meta.env.VITE_AM_GRAPHQL_URL;
import * as Sentry from '@sentry/react';
export const fetchGql = async (query: string, variables?: Record<string, unknown>) => {
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  }).catch((error) => {
    Sentry.captureException(error);
    throw error;
  });
  const json = await response.json();
  return json;
};
